import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { fadeInUp } from '../../utils/animation';

type DashboardButtonProps = {
  backgroundColor?: string;
};

export const DashboardButtonStyled = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'backgroundColor',
})<DashboardButtonProps>(({ theme, backgroundColor }) => ({
  backgroundColor: backgroundColor || 'var(--color-element)',
  borderRadius: '16px',
  height: '133px',
  textTransform: 'none',
  width: '100%',
  minWidth: '160px',
  padding: '16px',
  justifyContent: 'flex-start',
  animation: `${fadeInUp} 0.4s ease forwards`,
  opacity: 0,
  [theme.breakpoints.down('sm')]: {
    minWidth: 'unset',
  },
  '& svg': {
    height: '32px',
    width: 'auto',
    path: {
      strokeWidth: '1px',
      stroke: 'var(--color-type-primary)'
    },
  },
}));
